import { create } from 'zustand';
import { userApi } from '../services/api';
import { extractErrorResult } from '../utils/errorMessages';

// Non-sensitive user data for dropdowns and task assignment
interface UserListItem {
  id: string;
  firstName: string;
  lastName: string;
  avatar?: string | null;
}

interface UserStore {
  users: UserListItem[];
  fetchUsers: () => Promise<void>;
  isLoading: boolean;
}

export const useUserStore = create<UserStore>((set) => ({
  users: [],
  isLoading: false,

  fetchUsers: async () => {
    set({ isLoading: true });
    try {
      // Use the secure endpoint that only returns non-sensitive user data
      const response = await userApi.getUsersListNames();
      if (response.success && Array.isArray(response.data)) {
        set({ users: response.data as UserListItem[] });
      }
    } catch (error: unknown) {
      const { message } = extractErrorResult(error);
      console.error('Failed to fetch users:', message);
    } finally {
      set({ isLoading: false });
    }
  },
}));